import { Dispatch, SetStateAction } from "react";
import { Button } from "@tellescope/design-system";
import {
  DestructiveConfirmDialog,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@tellescope/ui";
import { Copy, Ellipsis, Eye, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface BlockActionsProps {
  setEditMode?: Dispatch<SetStateAction<boolean>>;
  duplicateBlock: () => void;
  deleteBlock: () => void;
  canCreateBlock: boolean;
  canDeleteBlock: boolean;
}

export const BlockActions = ({
  setEditMode,
  duplicateBlock,
  deleteBlock,
  canCreateBlock,
  canDeleteBlock,
}: BlockActionsProps) => {
  const { t } = useTranslation("contacts");

  if (!setEditMode && !canCreateBlock && !canDeleteBlock) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button iconOnly variant="ghost" color="muted" size="sm" data-testid="block-actions-trigger">
          <Ellipsis />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {!!setEditMode && (
          <DropdownMenuItem onClick={() => setEditMode(true)} className="cursor-pointer">
            <Eye />
            {t("View more")}
          </DropdownMenuItem>
        )}
        {canCreateBlock && (
          <DropdownMenuItem onClick={() => duplicateBlock()} className="cursor-pointer">
            <Copy />
            {t("Duplicate")}
          </DropdownMenuItem>
        )}
        {canDeleteBlock && (
          <DestructiveConfirmDialog onConfirm={() => deleteBlock()}>
            <DropdownMenuItem variant="destructive" className="cursor-pointer">
              <Trash2 className="text-destructive" />
              {t("Delete")}
            </DropdownMenuItem>
          </DestructiveConfirmDialog>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
